import * as React from 'react';
import Text from './Text'

export default function TextLatin({ value }) {
  return <Text label="Łacinka" disabled={true} value={value} />;
}
